import React from 'react';
import {
  ServicesSection,
  Container,
  SectionHeader,
  SectionTitle,
  SectionSubtitle,
  ServicesGrid,
  ServiceCard,
  ServiceIcon,
  ServiceTitle,
  ServiceDescription,
  ServiceKeywords,
  KeywordTag,
  ServiceBtn,
  ServicesCta,
  CtaButton
} from './Services.styles.jsx';

const Services = () => {
  const services = [
    {
      id: 1,
      title: "Instalații Sanitare",
      description: "Montaj și reparații complete instalații sanitare, baterii, chiuvete, dus, wc, vas geberit și toate accesoriile sanitare.",
      icon: "🚿",
      keywords: ["instalații", "sanitare", "baterii", "chiuvete", "dus", "montaj", "reparații"]
    },
    {
      id: 2,
      title: "Încălzire în Pardoseală",
      description: "Instalare și reparații sisteme de încălzire în pardoseală pentru confort maxim în casa ta.",
      icon: "🔥",
      keywords: ["încălzire", "pardoseală", "instalații", "montaj", "reparații"]
    },
    {
      id: 3,
      title: "Curățare Chimică Centrale",
      description: "Servicii profesionale de curățare și spălare chimică pentru centrale termice și boiler.",
      icon: "🧽",
      keywords: ["curățare", "chimică", "centrale", "spălare", "boiler"]
    },
    {
      id: 4,
      title: "Montaj Calorifere",
      description: "Instalare și montaj calorifere noi (din fontă, aluminiu, panel și portprosop), reparații și întreținere sisteme de încălzire.",
      icon: "🌡️",
      keywords: ["montaj", "calorifere", "instalații", "încălzire", "reparații"]
    },
    {
      id: 5,
      title: "Reparații Instalații",
      description: "Reparații rapide și eficiente pentru toate tipurile de instalații sanitare și de încălzire.",
      icon: "🔧",
      keywords: ["reparații", "instalații", "sanitare", "încălzire", "urgente"]
    },
    {
      id: 6,
      title: "Consultanță Tehnică",
      description: "Consultații gratuite pentru alegerea celor mai bune soluții de instalații pentru casa ta.",
      icon: "💡",
      keywords: ["consultanță", "tehnică", "instalații", "consultații", "gratuite"]
    }
  ];

  return (
    <ServicesSection id="servicii">
      <Container>
        <SectionHeader>
          <SectionTitle>Serviciile Noastre</SectionTitle>
          <SectionSubtitle>
            Oferim servicii complete de instalații sanitare și de încălzire de calitate, cu garanție.
          </SectionSubtitle>
        </SectionHeader>

        <ServicesGrid>
          {services.map(service => (
            <ServiceCard key={service.id}>
              <ServiceIcon>{service.icon}</ServiceIcon>
              <ServiceTitle>{service.title}</ServiceTitle>
              <ServiceDescription>{service.description}</ServiceDescription>
              <ServiceKeywords>
                {service.keywords.map((keyword, index) => (
                  <KeywordTag key={index}>{keyword}</KeywordTag>
                ))}
              </ServiceKeywords>
              <ServiceBtn href="#contact">Cere Oferta</ServiceBtn>
            </ServiceCard>
          ))}
        </ServicesGrid>

        <ServicesCta>
          <h3>Ai nevoie de ajutor cu instalațiile?</h3>
          <p>Contactați-ne pentru o consultație gratuită și ofertă personalizată</p>
          <CtaButton href="tel:+40721150463">
            Sună Acum: +40721150463
          </CtaButton>
        </ServicesCta>
      </Container>
    </ServicesSection>
  );
};

export default Services;

